import React, { useEffect, useState } from "react";
import Resume from "./reworkProductDetail.view";
import { useTranslation } from "react-i18next";
import * as reworkProductServices from "../../../../services/reworkProductServices";

import { REPROCESS_TYPE } from "../../../../constants";
import { useReadBigBag } from "../../standAloneProcess/hook/useReadBigBag";
import { useStandAloneProcess } from "../../standAloneProcess/hook/useStandAloneProcess";
import { useNavigate } from "react-router-dom";
import PATHS from "../../../../constants/paths";
import { useReworkProduct } from "../hook/useReworkProduct";
import ReworkProductDetailReadBB from "./reworkProductDetailReadBB";
import showDialog from "../../../utils/ShowDialog/ShowDialog";
import * as itemService from "../../../../services/ItemService";

const ReworkProductResumeContainer = ({ uuid }) => {
  const processType = REPROCESS_TYPE;
  const [outPoints, setOutPoints] = useState();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [data, setData] = useState(null);
  const [type, setType] = useState(null);
  const [setShowPoint] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [showResume, setShowResume] = useState(true);
  const [setAction] = useState("");
  const { initial } = useReadBigBag();

  const onSucces = () => {
    setRefresh((prev) => !prev);
  };

  const { handlerDelete, handlerRemove, handlerFinish } = useReworkProduct(
    null,
    onSucces,
  );

  useEffect(() => {
    const fetchData = async () => {
      if (!uuid) return;

      const result = await reworkProductServices.getDetail(uuid);
      setData(result);
      setOutPoints(
        result.outputs?.map((o) => ({
          code: o.code,
          label: o.name,
        })) || [],
      );
    };

    fetchData();
  }, [refresh, uuid]);

  const goBack = async () => {
    navigate(PATHS.REWORK_PRODUCT_LIST);
  };

  const handlerOpenReworkProduct = () => {
    setType(null);
    setShowPoint(true);
    setShowResume(false);
    setAction("open");
  };
  const handlerOnSave = async (bbData) => {
    const values = {
      processUuid: data.uuid,
      itemCode: bbData.itemCode,
      batch: bbData.outBatch,
      weight: bbData.outWeight,
      harvestYear: bbData.harvestYear,
      sscc: bbData.sscc,
      productionDate: bbData.productionDate
        ? bbData.productionDate
        : Date.now(),
      entryPoint: data.entryPoint,
      outPoint: bbData.outPoint,
      type: type,
    };

    try {
      let title = "";
      let text = "";
      let icon = "";
      if (data.itemCodeProcessed !== bbData.outBatch.match(/[a-zA-Z]/)?.[0]) {
        title = "Error";
        text = t("forms.inventary.messages.registerBB.varietyError");
        icon = "error";
        showDialog(title, text, icon, false, "OK", false);
      } else {
        let result = await reworkProductServices.registerBB(values);

        const okAction = () => {
          setShowResume(true)
          setRefresh((prev) => !prev);
        };

        if (result) {
          title = t("forms.inventary.messages.registerBB.title");
          text = t("forms.inventary.messages.registerBB.text");
          icon = "success";
          showDialog(title, text, icon, false, "OK", false, okAction);
        } else {
          title = "Error";
          text = t("forms.inventary.messages.registerBB.error");
          icon = "error";
          showDialog(title, text, icon, false, "OK", false);
        }
      }
    } catch (error) {}
  };

  const handlerRead = (value, type) => {
    if (value === true) {
      setRefresh((prev) => !prev);
      setShowResume(value);
    } else {
      setShowResume(value);
    }
    setType(type);
  };

  return (
    <>
      {showResume !== false ? (
        <Resume
          data={data}
          openReworkProduct={handlerOpenReworkProduct}
          readBB={handlerRead}
          finish={handlerFinish}
          onDelete={handlerDelete}
          removeItem={handlerRemove}
          goBack={goBack}
        />
      ) : (
        <ReworkProductDetailReadBB
          goBack={handlerRead}
          onSave={handlerOnSave}
          outPoints={data.outputs}
          type={type}
        />
      )}
    </>
  );
};

ReworkProductResumeContainer.propTypes = {};

export default ReworkProductResumeContainer;
